import Layout from '@/layout';
var adRouter = {
  path: '/ad',
  component: Layout,
  redirect: '/ad/list',
  name: 'Ad',
  alwaysShow: true,
  meta: {
    title: '广告',
    icon: 'clipboard'
  },
  children: [{
    path: 'list',
    name: 'AdManager',
    component: function component() {
      return import('@/views/adManager/index');
    },
    meta: {
      title: '广告管理',
      icon: 'clipboard'
    }
  }]
};
export default adRouter;